<template>
		<div>
				<v-dialog
						v-model="modalAddLabel"
						width="500"
				>

						<v-card>
								<v-card-title class="headline grey lighten-2">
										Adicionar Etiquetas
								</v-card-title>

								<v-card-text>
										<v-autocomplete
												v-model="insertLabel"
												chips
												label="Etiquetas"
												item-text="name"
												clearable
												return-object
												:items="getLabels"
												full-width
												dense
												single-line
										>
												<template v-slot:selection="data">
														<v-chip
																v-bind="data.attrs"
																:input-value="data.selected"
																:color="data.item.color"
																class="white--text"
														>
																{{ data.item.name }}
														</v-chip>
												</template>
										</v-autocomplete>
								</v-card-text>

								<v-divider></v-divider>

								<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
												color="primary"
												@click="addLabel"
										>
												Adicionar
										</v-btn>
								</v-card-actions>
						</v-card>

				</v-dialog>
				<v-dialog
						v-model="attachments"
						width="900"
						ref="dialgFile"
				>

						<v-card>
								<v-card-title class="headline primary white--text">
										Arquivos Em anexo
								</v-card-title>
								<v-card-text>
										<FilesInDocument v-if="filesDocumentCurrent.length !== 0 " :filesrcs="filesDocumentCurrent"></FilesInDocument>
										<span v-else>Não há Arquivos anexados!</span>
								</v-card-text>


						</v-card>

				</v-dialog>
				<v-card elevation="1" class="pa-auto ">
						<v-card-text>
								<v-row no-gutters justify="start" align="center">
										<v-col cols="7">
												<v-row justify="start" no-gutters>

														<span class="text-body-2">{{documentType.name}} - {{document.number}} - {{documentTitle}} </span>

														<div class="ml-8">
																<!--								<v-chip-->
																<!--										color="purple darken-2 "-->
																<!--										label-->
																<!--										x-small-->
																<!--								>-->
																<!--									<span class="white&#45;&#45;text">Tramitando</span>-->
																<!--								</v-chip>-->
														</div>
												</v-row>
										</v-col>

										<v-col cols="4" class="ml-auto">
												<v-row no-gutters justify="end">
														<v-col cols="2" >
																<v-row no-gutters justify="end">
																		<v-tooltip bottom>
																				<template v-slot:activator="{ on, attrs }">
																						<v-icon v-bind="attrs" v-on="on" color="primary">mdi-swap-horizontal</v-icon>
																						<span class="text-caption primary--text ml-1">{{countProcedures}}</span>
																				</template>
																				<span>Tramitações</span>
																		</v-tooltip>
																</v-row>
														</v-col>
														<v-col cols="2">
																<v-row no-gutters justify="end">
																		<v-tooltip bottom>
																				<template v-slot:activator="{ on, attrs }">
																						<v-icon v-bind="attrs" v-on="on" color="primary">mdi-draw</v-icon>
																						<span class="text-caption primary--text ml-1">{{countersignUser}}</span>
																				</template>
																				<span>Assinaturas</span>
																		</v-tooltip>
																</v-row>
														</v-col>
														<v-col cols="2">
																<v-row no-gutters justify="end">
																		<v-tooltip bottom>
																				<template v-slot:activator="{ on, attrs }">
																						<v-icon v-bind="attrs" v-on="on" color="primary">mdi-eye-outline</v-icon>
																						<span class="text-caption primary--text ml-1">{{countersignUsereye}}</span>
																				</template>
																				<span>Visualizações</span>
																		</v-tooltip>
																</v-row>
														</v-col>
														<v-col cols="2">
																<v-row no-gutters justify="end">
																		<v-tooltip bottom>
																				<template v-slot:activator="{ on, attrs }">
																						<v-icon v-bind="attrs" v-on="on" @click="attachments = !attachments" color="primary">
																								mdi-paperclip
																						</v-icon>
																						<span class="text-caption primary--text ml-1">{{filesDocumentCurrent.length}}</span>
																				</template>
																				<span>Anexos</span>
																		</v-tooltip>
																</v-row>
														</v-col>

														<v-col cols="2">
																<v-row no-gutters justify="end">
																		<v-tooltip bottom>
																				<template v-slot:activator="{ on, attrs }">
																						<v-btn small v-bind="attrs" v-on="on" @click="bookmarkDocument" icon>
																								<v-icon :color="favorite ? 'primary' : ''">fa-star</v-icon>
																						</v-btn>
																				</template>
																				<span>Favoritos</span>
																		</v-tooltip>
																</v-row>
														</v-col>

												</v-row>
										</v-col>

								</v-row>
								<v-divider></v-divider>
								<div v-if="documentInital">
										<v-row no-gutters justify="start" :align="expand ? 'start': 'center'">

												<v-col cols="3">
														<v-row justify="start" class="mb-2" no-gutters>
																<span> Criador por</span>
														</v-row>
														<v-row no-gutters justify="start">
																<v-card
																		width="95%"
																		height="10%"
																		elevation="0"
																		outlined
																		class="teste"
																		style="border-radius: 6px"
																>
																		<v-list dense>
																				<v-list-item dense class="pa-0">
																						<v-list-item-icon class="ml-2 mr-3">

																								<v-avatar v-if="documentUserInitial.avatar" size="30">
																										<v-img :src="documentUserInitial.avatar" :alt="documentUserInitial.name"/>
																								</v-avatar>
																								<v-avatar v-else color="primary" size="30">
																										<span class="white--text text-h6">{{ documentUserInitial.name | nameAvatar }}</span>
																								</v-avatar>


																						</v-list-item-icon>
																						<v-list-item-content>
																								<v-list-item-title class="text-subtitle-1 font-weight-bold ">{{documentInital.user.name}}
																								</v-list-item-title>
																								<v-list-item-subtitle class="text-caption text-lg-caption ">{{this.positionDocumentInitial !==
																										undefined ? this.positionDocumentInitial.position_pivot.position[0].name:''}}
																								</v-list-item-subtitle>
																						</v-list-item-content>
																				</v-list-item>
																		</v-list>
																</v-card>
														</v-row>
												</v-col>
												<v-col cols="9">

														<v-row no-gutters class="mb-2">
																<span class="text-caption grey--text">Documento Inicial - {{documentInital.number}}</span>
														</v-row>
														<v-row no-gutters>
																<v-card
																		elevation="2"
																		height="10%"
																		class="teste"
																		width="100%"
																>
																		<v-card-title>
																				<span class="text-title">{{documentInital.subject}}</span>
																				<v-spacer></v-spacer>
																				<v-btn @click="expand = !expand" icon>
																						<v-icon color="primary">{{expand ? 'mdi-minus-circle-outline' : 'mdi-plus-circle-outline'}}
																						</v-icon>
																				</v-btn>
																		</v-card-title>
																		<v-card-text>
																				<v-expand-transition mode="in">
																						<span v-if="expand === false" v-html="documentInital.content.slice(0,200)+'...'"></span>
																						<v-card elevation="0" v-else>
																								<span v-html="documentInital.content.slice(0,documentInital.content.length)"></span>
																						</v-card>

																				</v-expand-transition>

																		</v-card-text>
																		<v-card-actions class="justify-end">

																				<span class="text-caption grey--text">{{documentInital.created_at | correctDatePt_br}}</span>
																		</v-card-actions>
																</v-card>
														</v-row>
												</v-col>
										</v-row>
										<v-divider v-if="documentInital" class="mt-3"></v-divider>
								</div>
								<!--    documento atual-->
								<v-row class="mt-3" no-gutters justify="start" align="start">

										<v-col cols="3">
												<v-row class="mt-2 mb-2" dense no-gutters>
												</v-row>
												<v-row class="mt-2 mb-2" dense no-gutters>
														<span><strong>De: </strong> <span class="text-caption">{{documentEntityCreate.initials}}</span></span>
												</v-row>
												<v-row class="mt-2 mb-2" dense no-gutters>
														<span><strong>Para: </strong> <span class="text-caption">{{documentEntityFor.initial}}</span></span>
												</v-row>
												<v-row class="mt-2 mb-2" dense no-gutters>
														<span><strong>Urgente: </strong> <span class="text-caption">{{urgent ? 'Sim':'Não'}}</span></span>
												</v-row>
												<v-row class="mt-2 mb-2" dense no-gutters>
														<span><strong>A/C: </strong> <span class="text-caption">{{documentCure}}</span></span>
												</v-row>
												<v-row class="mt-4 mb-2" dense no-gutters>
														<span v-if="countProcedures == 1 ">Criado por</span>
														<span v-else>Despachado por</span>
												</v-row>
												<v-row class="mt-2 mb-2" dense no-gutters justify="start">
														<v-card
																width="95%"
																elevation="0"
																outlined
																style="border-radius: 10px"
														>
																<v-list dense>
																		<v-list-item dense class="pa-0">
																				<v-list-item-icon class="ml-2 mr-3">

																						<v-avatar v-if="documentCreteUser.avatar" size="30">
																								<v-img :src="documentCreteUser.avatar" :alt="documentCreteUser.name"/>
																						</v-avatar>
																						<v-avatar v-else color="primary" size="30">
																								<span class="white--text text-h6">{{documentCreteUser.name | nameAvatar}}</span>
																						</v-avatar>

																				</v-list-item-icon>
																				<v-list-item-content>
																						<v-list-item-title class="text-subtitle-1  font-weight-bold ">{{documentCreteUser.name}}
																						</v-list-item-title>
																						<v-list-item-subtitle class="text-caption">{{documentUserCreatPosition}}</v-list-item-subtitle>
																				</v-list-item-content>
																		</v-list-item>
																</v-list>
														</v-card>
												</v-row>
												<v-row class="mt-4 mb-2" dense no-gutters>
														<span v-if="document.countersign != null">Assinado por</span>
												</v-row>
												<v-row v-if="document.countersign != null" class="mt-2 mb-2" dense no-gutters justify="start">
														<v-card
																width="95%"
																elevation="0"
																outlined
																style="border-radius: 10px"
														>
																<v-list dense>
																		<v-list-item dense class="pa-0">
																				<v-list-item-icon class="ml-2 mr-3">

																						<v-avatar v-if="document.countersign_user.avatar" size="30">
																								<v-img :src="document.countersign_user.avatar" :alt="document.countersign_user.name"/>
																						</v-avatar>
																						<v-avatar v-else color="primary" size="30">
																								<span class="white--text text-h6">{{document.countersign_user.name | nameAvatar}}</span>
																						</v-avatar>

																				</v-list-item-icon>
																				<v-list-item-content>
																						<v-list-item-title class="text-subtitle-1  font-weight-bold ">{{document.countersign_user.name}}
																						</v-list-item-title>
																						<v-list-item-subtitle class="text-caption">
																								{{userPositionCountersign[0].position_pivot.position[0].name}}
																						</v-list-item-subtitle>
																				</v-list-item-content>
																		</v-list-item>
																</v-list>
														</v-card>
												</v-row>
												<v-row class="mt-4 mb-2" dense no-gutters justify="start">
              <span class="mt-1">
       Etiquetas
      </span>
														<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																		<v-btn @click="openModalLabel" icon>
																				<v-icon
																						color="primary"
																						dark
																						v-bind="attrs"
																						v-on="on"
																				>
																						mdi-plus-circle-outline
																				</v-icon>
																		</v-btn>
																</template>
																<span>Adicionar etiqueta</span>
														</v-tooltip>
												</v-row>
												<v-row class="mb-2" dense no-gutters justify="start">
														<div v-for="(value,index) in labels" :key="index" class="d-inline">
																<v-chip
																		class="ma-1"
																		close
																		:color="value.color"
																		text-color="white"
																		close-icon="mdi-delete"
																		@click:close="deleteItemLabel(value)"
																		small
																>
																		{{value.name}}


																</v-chip>
														</div>
												</v-row>

										</v-col>
										<v-col cols="9">
												<v-row no-gutters>
														<span class="text-caption grey--text">Ultima Movimentaçâo -  Despacho  {{countProcedures}}</span>
												</v-row>
												<v-row no-gutters>
														<v-card
																elevation="2"
																height="10%"
																width="100%"
														>
																<v-card-title>
																		<span class="text-title">{{documentTitle}}</span>
																		<v-spacer></v-spacer>
																		<v-btn @click="expandReceive_text = !expandReceive_text" icon>
																				<v-icon color="primary">{{expandReceive_text ? 'mdi-minus-circle-outline' :
																						'mdi-plus-circle-outline'}}
																				</v-icon>
																		</v-btn>
																</v-card-title>
																<v-card-text class=" text-caption text-justify">
																		<v-expand-transition mode="in">
																				<span v-if="expandReceive_text === false" v-html="receive_text.slice(0,200)+'....'"></span>
																				<v-card elevation="0" v-else>
																						<span v-html="receive_text.slice(0,receive_text.length)"></span>
																				</v-card>

																		</v-expand-transition>

																</v-card-text>
																<v-card-actions class="justify-end">

																		<span class="text-caption grey--text">{{dateCreateDocument}}</span>
																</v-card-actions>
														</v-card>
												</v-row>
										</v-col>
								</v-row>
								<v-row class="mt-6" no-gutters>
										<v-col cols="3">
												<v-row no-gutters dense justify="start">
														<v-col cols="6">
																<v-btn @click="answerDocument" color="primary">
																		<span class="text-caption"> Responder </span>
																		<v-icon
																				right
																				dark
																				small
																		>
																				mdi-undo-variant
																		</v-icon>
																</v-btn>
														</v-col>
														<v-col cols="6">
																<v-btn width="90%" outlined @click="Documentforward" color="primary">
																		<span class="text-caption">Encaminhar</span>
																</v-btn>
														</v-col>
												</v-row>
										</v-col>
										<v-col cols="9">
												<v-card height="100%">
														<v-card-text class="py-0">
																<v-row align="center" no-gutters>
																		<span class="primary--text">Ver Todo historico de Despachos</span>
																		<v-spacer></v-spacer>
																		<v-btn @click="openHistory" icon>
																				<v-icon color="primary">mdi-plus-circle-outline</v-icon>
																		</v-btn>
																</v-row>
														</v-card-text>
												</v-card>
										</v-col>
								</v-row>
						</v-card-text>
				</v-card>

				<!--   historico de tramitaçcao-->
				<v-card
						class="mt-2"
						v-if="historyCard"
						elevation="0"
						color="#AFB3AF"
						id="history"
				>
						<v-card-text>
								<template v-for="(item,i) in documentHistory">
										<document-history-show :documentCurrent="document" :item="item" :key="`item-${i}`"
										                       :number="i"></document-history-show>
								</template>
						</v-card-text>
				</v-card>
				<v-dialog
						v-model="historyCardDialog"
						max-width="290"
				>
						<v-card>
								<v-card-title class="headline">
										Alerta
								</v-card-title>
								<v-card-text>Nâo há historico de Tramitação</v-card-text>
						</v-card>
				</v-dialog>

				<!--   respota do documento -->
				<validation-observer ref='observer' v-slot='{ passes }'>
						<div>
								<v-dialog
										v-model="progressAnswer"
										hide-overlay
										internal-activator
										persistent
										width="300"
								>
										<v-card
												color="primary"
												dark
												v-if="progressAnswer"
										>
												<v-card-text>
														Processando Documento
														<v-progress-linear

																indeterminate
																color="white"
																class="mb-0"
														></v-progress-linear>
												</v-card-text>
										</v-card>
								</v-dialog>


								<v-card
										:disabled="disbleCardAnswer"
										class="mt-2"
										v-if="btnAnswerDocument"
										elevation="2"
										id="answer"
								>
										<!--					<v-progress-linear-->
										<!--							:active="progressAnswer"-->
										<!--							:indeterminate="progressAnswer"-->
										<!--							absolute-->
										<!--							top-->
										<!--							rounded-->
										<!--							color="primary accent-4"-->
										<!--					></v-progress-linear>-->

										<v-card-title>
												<v-row>
														<v-col>
																<v-row align="center" no-gutters>

        <span class="text-body-2">
	        Responder
        </span>

																</v-row>
																<v-row align="center" no-gutters>

        <span class="text-body-2">

         <strong>Para:</strong> {{documentEntityCreate.initials}} </span>

																		<!--							<v-btn @click="inputCare"  color="primary"   class="ml-16" >-->

																		<!--									A/C-->


																		<!--							</v-btn>-->
																		<!--							<span class="ml-3">|</span>-->
																		<!--							<v-btn class="ml-3" icon>-->
																		<!--								+CC-->
																		<!--							</v-btn>-->

																		<v-checkbox
																				label="Urgente"
																				hide-details
																				v-model="urgent"
																				dense
																				class="mt-0 ml-3"
																		>

																		</v-checkbox>
																		<v-checkbox
																				label="Privado"
																				hide-details
																				v-model="privet"
																				dense
																				class="mt-0 ml-3"
																		>

																		</v-checkbox>
																</v-row>
																<v-row no-gutters>
																		<v-menu

																				ref="menuShow"
																				v-model="menuCalendar"
																				:close-on-content-click="false"
																				transition="scale-transition"
																				offset-y
																				min-width="290px"
																		>
																				<template v-slot:activator="{ on }">
									<span><strong class="text-body-2 font-weight-bold">Prazo: </strong>
										<v-chip
												color="primary"
												small
												v-on="on"
										>
										<span class="font-weight-bold">	{{dateDeadline === '' ? 'Sem Prazo' : dateDeadline | correctDate   }}</span>
										</v-chip>
									</span>
																				</template>
																				<v-date-picker :min="currentDate" locale="pt" v-model="dateDeadline" no-title scrollable>
																						<div class="flex-grow-1"></div>
																						<v-btn text color="primary" @click="menuCalendar = false">Cancel</v-btn>
																						<v-btn text color="primary" @click="$refs.menuShow.save(date)">OK</v-btn>
																				</v-date-picker>
																		</v-menu>
																</v-row>
																<v-row class="mt-3" no-gutters>
																		<v-col cols="6">
																				<v-text-field v-model="documentTitle" dense outlined label="Assunto"></v-text-field>
																		</v-col>
																</v-row>
																<v-row class="mt-3" no-gutters>
																		<v-col cols="6">
																				<validation-provider rules="required" v-slot="{ errors }" name="selectedUserEntiyAc">

																						<v-autocomplete
																								v-model="selectedUserEntiyAc"
																								chips
																								label="A/C"
																								item-text="name"
																								return-object
																								outlined
																								dense
																								small-chips
																								:error-messages="errors"
																								:items="usersEntity"

																						>
																						</v-autocomplete>
																				</validation-provider>
																		</v-col>
																</v-row>
														</v-col>
												</v-row>
										</v-card-title>
										<v-card-text>
												<v-row no-gutters>
														<v-col>
																<ckeditor ref="teset" placeholder="Type here..." v-model="content" tag-name="textarea"
																          :config="$store.state.editorConfig"></ckeditor>

																<!--						<editor-text  @getValue="getValue" ></editor-text>-->
														</v-col>
												</v-row>
												<v-row class="mt-10" no-gutters>
														<v-col cols="6">

																<v-file-input
																		dense
																		v-model="files"
																		color="primary accent-4"
																		counter
																		multiple
																		placeholder="Arquivos"
																		prepend-icon="mdi-paperclip"
																		outlined
																		truncate-length="11"
																		:show-size="1000"
																>
																		<template v-slot:selection="{ index, text }">
																				<v-chip
																						v-if="index < 2"
																						color="primary accent-4"
																						dark
																						close
																						label
																						small
																						@click:close="remove(index)"
																				>
																						{{ text }}
																				</v-chip>

																				<span
																						v-else-if="index === 2"
																						class="overline grey--text text--darken-3 mx-2"
																				>
                          +{{ files.length - 2 }} File(s)
                      </span>
																		</template>
																</v-file-input>
														</v-col>
														<v-col cols="2">

														</v-col>
														<v-col cols="4">
																<v-row no-gutters>
																		<v-col cols="6">
																				<v-btn
																						:disabled="progressAnswer"
																						color="primary"
																						@click="passes(respond)"
																				>
																						Enviar
																				</v-btn>
																		</v-col>
																		<v-col cols="6">
																				<v-btn
																						color="primary"
																						outlined
																						@click="cancel"
																				>
																						Cancelar
																				</v-btn>
																		</v-col>
																</v-row>
														</v-col>

												</v-row>
										</v-card-text>

								</v-card>
						</div>
				</validation-observer>


				<!--   encaminhar do documento -->
				<validation-observer ref='observer' v-slot='{ passes }'>
						<v-card
								:disabled="disbleCardRever"
								class="mt-2"
								v-if="btnDocumentforward"
								elevation="2"
								id="forward"
						>
								<v-card-title>
										<v-row>
												<v-col>
														<v-row align="center" no-gutters>

        <span class="text-body-2">
	        Encaminhar
        </span>
														</v-row>
														<v-row class="mt-3" align="center" no-gutters>

																<v-col cols="6">
																		<validation-provider rules="required" v-slot="{ errors }" name="selectedEntiy">
																				<v-autocomplete
																						:items="gEntitiesSelect"
																						return-object
																						item-text="name"
																						dense
																						clear-icon="mdi-close-circle-outline"
																						clearable
																						outlined
																						@input="selectUsersEntities"
																						label="Para"
																						v-model="documentforwardEntity"
																						:error-messages="errors"
																				>

																				</v-autocomplete>
																		</validation-provider>
																</v-col>
														</v-row>
														<v-row no-gutters>
																<v-checkbox
																		label="Urgente"
																		v-model="urgent"
																		dense

																>

																</v-checkbox>
																<v-checkbox
																		label="Privado"
																		v-model="privet"
																		dense
																		class="ml-3"
																>

																</v-checkbox>

																<v-menu

																		ref="menuShow"
																		v-model="menuCalendar"
																		:close-on-content-click="false"
																		transition="scale-transition"
																		offset-y
																		min-width="290px"
																>
																		<template v-slot:activator="{ on }">
									<span class="ml-6 mt-3"><strong class="text-body-2 font-weight-bold">Prazo: </strong>
										<v-chip
												color="primary"
												small
												v-on="on"
										>
										<span class="font-weight-bold">	{{dateDeadline === '' ? 'Sem Prazo' : dateDeadline | correctDate   }}</span>
										</v-chip>
									</span>
																		</template>
																		<v-date-picker :min="currentDate" locale="pt" v-model="dateDeadline" no-title scrollable>
																				<div class="flex-grow-1"></div>
																				<v-btn text color="primary" @click="menuCalendar = false">Cancel</v-btn>
																				<v-btn text color="primary" @click="$refs.menuShow.save(date)">OK</v-btn>
																		</v-date-picker>
																</v-menu>
														</v-row>
														<v-row class="mt-3" no-gutters>
																<v-col cols="6">
																		<v-text-field dense v-model="documentTitle" outlined label="Assunto"></v-text-field>
																</v-col>
														</v-row>
														<v-row class="mt-3" no-gutters>
																<v-col cols="6">
																		<validation-provider rules="required" v-slot="{ errors }" name="selectedUserEntiyforward">
																				<v-autocomplete
																						v-model="selectedUserEntiyforward"
																						chips
																						v-if="care"
																						label="A/C"
																						outlined
																						item-text="name"
																						return-object
																						:items="usersEntity"
																						full-width
																						clearable
																						:error-messages="errors"
																						dense
																						single-line
																				>
																						<template v-slot:append-outer>
																								<v-slide-x-reverse-transition
																										mode="out-in"
																								>
																										<v-btn icon @click=" care = false">
																												<v-icon

																												>mdi-close-circle-outline
																												</v-icon>
																										</v-btn>
																								</v-slide-x-reverse-transition>
																						</template>
																				</v-autocomplete>
																		</validation-provider>
																</v-col>
														</v-row>
												</v-col>
										</v-row>
								</v-card-title>
								<v-card-text>
										<v-row no-gutters>
												<v-col>
														<ckeditor ref="teset" placeholder="Type here..." v-model="content" tag-name="textarea"
														          :config="$store.state.editorConfig"></ckeditor>

												</v-col>
										</v-row>
										<v-row class="mt-10" no-gutters>
												<v-col cols="6">

														<v-file-input
																dense
																v-model="files"
																color="primary accent-4"
																counter
																multiple
																placeholder="Arquivos"
																prepend-icon="mdi-paperclip"
																outlined
																truncate-length="11"
																:show-size="1000"
														>
																<template v-slot:selection="{ index, text }">
																		<v-chip
																				v-if="index < 2"
																				color="primary accent-4"
																				dark
																				close
																				label
																				small
																				@click:close="remove(index)"
																		>
																				{{ text }}
																		</v-chip>

																		<span
																				v-else-if="index === 2"
																				class="overline grey--text text--darken-3 mx-2"
																		>
                          +{{ files.length - 2 }} File(s)
                      </span>
																</template>
														</v-file-input>
												</v-col>
												<v-col cols="2">

												</v-col>
												<v-col cols="4">
														<v-row no-gutters>
																<v-col cols="6">
																		<v-btn
																				color="primary"
																				@click="passes(refer)"
																		>
																				Enviar
																		</v-btn>
																</v-col>
																<v-col cols="6">
																		<v-btn
																				color="primary"
																				outlined
																				@click="cancel"
																		>
																				Cancelar
																		</v-btn>
																</v-col>
														</v-row>
												</v-col>

										</v-row>
								</v-card-text>

						</v-card>
				</validation-observer>


		</div>
</template>

<script>
 import DocumentHistoryShow from "./DocumentHistoryShow";
 import movingDocument from '@/services/register-document'
 // import data from './Dados'
 import {ValidationObserver, ValidationProvider} from "vee-validate";
 import {apolloClient} from '@/vue-apollo'
 // eslint-disable-next-line no-unused-vars
 import moment from "moment";
 import FilesInDocument from "./FilesInDocument";

 export default {
  name: "DocumentShow",
  props:{
   bar:{
    type:Boolean
   },
  },
  components: {
   FilesInDocument,
   DocumentHistoryShow,
   ValidationObserver,
   ValidationProvider
  },


  data: () => ({
   expand: false,
   disbleCardRever:false,
   progressAnswer:false,
   receiverTypeAnswered:'',
   disbleCardAnswer:false,
   menuCalendar:false,
   dateDeadline:'',
   privet:false,
   historyCard: false,
   historyCardDialog:false,
   documentHistory:null,
   documentType: {},
   positionDocumentInitial:undefined,
   documentUserInitial:{},
   content:'',
   insertLabel:{},
   dateCreateDocument:'',
   currentDate: moment().subtract(0, 'days').format("YYYY-MM-DD"),
   care:false,
   btnDocumentforward:false,
   selectedUserEntiyforward:'',
   documentTitle: '',
   attachments:false,
   date:null,
   modalAddLabel:false,
   documentBoxIdcurrent:'',
   documentFolderIdcurrent:'',
   documentFolderProviusIdcurrent:'',
   actionDocument:'',
   getLabels:{},
   documentCreteUser:'',
   files: [],
   filesDocumentCurrent:[],
   urgent:false,
   favoritoID:'',
   countersignUsereye:0,
   documentforwardEntity:{},
	 gEntities:[],
   countProcedures:0,
   labels:[],
   entityId:'',
   documentBox:{},
   avartarUSer:false,
   documentEntityCreate:{},
   documentEntityFor:'',
   answerUser:null,
   documentUserCreatPosition:'',
   documentCure:'',
   qtdprocedures: 0,
	 userPositionCountersign:'',
   documentEntityForOb:{},
   document:{},
   documentInital:null,
		gEntitiesSelect:[],
   documentInitalUser:{},
   documentInital_id:'',
   selectedUserEntiyAc:'',
   parent: null,
   btnAnswerDocument: false,
   usersEntity:[],
   favorite: false,
   expandReceive_text: false,
   receive_text: '',
   countersignUser:0,
   documentId:null,
  }),
  apollo: {
   documentType:{
    query: require('@/graphql/queries/Documents.gql').documentTypesalias,
    variables:{
     alias:"memorando"
    },
    update: (data) => {
     return data.documentType
    }
   },
   receiverType: {
    query: require('@/graphql/queries/Documents.gql').ReceiverTypesAlias,
    variables: {
     alias: "to"
    },
    update: (data) => {
    
     return data.receiverType
    }
   },
   receiverTypeFrom:{
    query: require('@/graphql/queries/Documents.gql').ReceiverTypesAlias,
    variables: {
     alias: "from"
    },
    update: (data) => {
    
     return data.receiverType
    }
   },
		ReceiverCategoryforwarded: {
			query: require('@/graphql/queries/Documents.gql').ReceiverCategoryAlias,
			variables: {
				alias: "forwarded"
			},
			update: (data) => {
   
				return data.receiverCategory
			}
		},

		getEntities: {
			query: require('@/graphql/queries/Entity.gql').getEntitiesSelectUser,
			update: (data) => {
   
				return data.entities
			},
			error: (error) => {

				console.error(error)
			}
		},
   ReceiverCategoryanswered: {
    query: require('@/graphql/queries/Documents.gql').ReceiverCategoryAlias,
    variables: {
     alias: "answered"
    },
    update: (data) => {
    
     return data.receiverCategory
    },


   },
  },
  watch: {

   async documentInital(val){

    await this.$apollo.query({
     query:require('@/graphql/queries/User.gql').userQueryId,
     variables:{
      id:val.user.id
     },
    }).then(data=>{
     this.positionDocumentInitial = data.data.user.entities.filter(function (obj) {
      return obj.id === val.entity.id
     })[0]

    }).catch(err=>{
     console.log(err)
    })

   },
   btnAnswerDocument(val){
    if(val === true){
     this.care = true
    }

   },
   care(val){
    if (val) {
     this.$apollo.query({
      query: require('@/graphql/queries/Entity.gql').getEntityId,
      variables: {
       id: this.documentEntityCreate.id
      }
     }).then((data) => {
      this.usersEntity = data.data.entity.users
     }).catch((err) => {
      console.error(err)
     })
    }


   },
   documentCreteUser(val){


    this.avartarUSer = val.avatar.length !== 0 ? false : true
    if(val !== undefined){
     this.$apollo.query({
      query:require('@/graphql/queries/Position.gql').getUSerpositions,
      variables:{
       id:val.id
      }
     }).then((data)=>{
      this.documentUserCreatPosition = data.data.user.entities.filter((e)=>{
       return e.id === this.document.entity.id
      })[0].position_pivot.position[0].name

     }).catch(err=>{
      console.error(err)
     })
    }

   }

  },
  computed:{
   formattedDate: function () {


    var time = moment().format('HH:mm:ss')

    //console.log(this.dateDeadline.length === 0  ? 'teste':'certo')
    return this.dateDeadline.length === 0 ?  '' : moment(this.dateDeadline).format(`YYYY-MM-DD ${time}`);
   },

   dataCreatDocument(){


    return {
     number: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
     subject: this.documentTitle,
     content: this.content,
     delivery_time: this.formattedDate,
     private: this.privet,
     urgent: this.Urgent,
     client: this.$store.state.defaultClient.id,
     entity: this.$store.state.enti.id,
     document_type: this.documentType.id,
     user: this.$store.state.userID,
     countersign: null,
     countersign_user: null,
     parent: this.document.id,
     att_user: this.documentCreteUser.id,
     att_entity: this.documentEntityCreate.id,
     initial_document:this.documentInital_id
    }
   },
   dataTosendDestinyRespond(){

    return {
     entity: this.entityId,
     user: this.selectedUserEntiyAc.id,
     receiver_type:  this.receiverType.id,
     receiver_category: this.ReceiverCategoryanswered.id
    }
   },
   dataTosendFormeRespond(){
    return {
     entity: this.$store.state.enti.id,
     user: this.$store.state.userID,
     receiver_type: this.receiverTypeFrom.id,
     receiver_category: this.ReceiverCategoryanswered.id
    }
   },

   dataTosendDestinyRefer(){
    console.log({
     entity: this.documentforwardEntity,
     user: this.selectedUserEntiyforward,
     receiver_type:  this.receiverType,
     receiver_category: this.ReceiverCategoryforwarded
    })
    return {
     entity: this.documentforwardEntity.id,
     user: this.selectedUserEntiyforward.id,
     receiver_type:  this.receiverType.id,
     receiver_category: this.ReceiverCategoryforwarded.id
    }
   },
   dataTosendFormeRefer(){
    console.log({
     entity: this.$store.state.enti,
     user: this.$store.state.userID,
     receiver_type: this.receiverTypeFrom,
     receiver_category: this.ReceiverCategoryforwarded
    })
    return {
     entity: this.$store.state.enti.id,
     user: this.$store.state.userID,
     receiver_type: this.receiverTypeFrom.id,
     receiver_category: this.ReceiverCategoryforwarded.id
    }
   },


  },
  methods: {
   async fetchEvents() {

    if(this.documentInital !== null){
     await  this.$apollo.query({
      query:require('@/graphql/queries/Documents.gql').getDocumentHistory1,
      variables:{
       id:this.documentInital.id
      },
      fetchPolicy:'network-only'
     }).then((data)=>{
      var documentInitial = data.data.document
      let array = []
      var documentDescends = data.data.document.descendants
      delete documentInitial.descendants
      array = documentDescends
      array.unshift(documentInitial)
      this.documentHistory = array
      this.countProcedures = array.length
     }).catch(({graphQLErrors})=>{
      console.log(graphQLErrors)
     })
    }

   },


   getValue(val) {
    this.content = val
   },
   deleteItemLabel(item) {
    this.$apollo.mutate({
     mutation: require("@/graphql/mutations/Documents.gql").DeleteMutation,
     variables: {
      id:this.documentBox.id,
      label: [item.id]
     }
    }).then(() => {
    })
    let index = this.labels.findIndex(x => x.id === item)
    this.labels.splice(index, 1)
   },
   addLabel(){

    this.modalAddLabel = false
    this.$apollo.mutate({
     mutation:require('../../graphql/mutations/Label.gql').ligarlabelbox,
     variables:{
      id:this.documentBox.id,
      label:this.insertLabel.id
     }
    }).then(()=>{
     this.labels.push(this.insertLabel)
     this.insertLabel = {}
    }).catch((err)=>{
     console.error(err)
    })
   },
   async	openModalLabel(){

    await this.$apollo.query({
     query:require('../../graphql/queries/Label.gql').getLabels,
    }).then((data)=>{
     this.getLabels = data.data.labels
    }).catch((err)=>{
     console.error(err)
    })
    this.modalAddLabel = true
   },
   selectUsersEntities(){
    this.care = true
	   console.log(this.selectedUserEntiyforward)
    this.selectedUserEntiyforward =null
    this.documentforwardEntity
    this.$apollo.query({
     query: require('@/graphql/queries/Entity.gql').getEntityId,
     variables: {
      id:  this.documentforwardEntity.id
     }
    }).then((data) => {
     this.usersEntity = data.data.entity.users
    }).catch((err) => {
     console.error(err)
    })
   },
   async Documentforward(){

	await this.$apollo.query({
			query: require('@/graphql/queries/Entity.gql').getEntitiesSelectUser,
		}).then((data)=>{
		this.gEntitiesSelect =	 data.data.entities

		this.btnDocumentforward =  !this.btnDocumentforward
		this.historyCard = false
		this.btnAnswerDocument = false
		this.urgent = false
		this.$nextTick(() => this.$vuetify.goTo('#forward'))
		}).catch((err)=>{
			console.log(err)
		})

   },
   cancel(){
    this.btnAnswerDocument = false
    this.btnDocumentforward= false
   },
   async respond() {


    //  var arrayfiles =[]
    // let documentId =''
    this.progressAnswer = true
    this.disbleCardAnswer = true


    const dataDocument = await movingDocument.createDocument(this.dataCreatDocument)
    await  movingDocument.sendingToDestination(this.dataTosendDestinyRespond,dataDocument.id)
    await  movingDocument.sendingToMe(this.dataTosendFormeRespond,dataDocument.id)
    const dataDocumentFiles = await  movingDocument.filesDocument(this.files,dataDocument.id)

    if(dataDocumentFiles){
     this.progressAnswer = false
     this.disbleCardAnswer = false
     this.btnAnswerDocument=false
    }else{
     console.log('faltou')
    }

   },
  async refer(){

    const dataDocument = await movingDocument.createDocument(this.dataCreatDocument)
	   console.log(dataDocument,'documento criado com sucesso')
	  console.log(this.dataTosendDestinyRefer)
	   const dataDocumentReferTo  =  await  movingDocument.sendingToDestination(this.dataTosendDestinyRefer,dataDocument.id)
				console.log(dataDocumentReferTo,'enviado para destinatario')
	   console.log(this.dataTosendFormeRefer)
   const dataDocumentForMe =  await  movingDocument.sendingToMe(this.dataTosendFormeRefer,dataDocument.id)
	  console.log(dataDocumentForMe,'enviando para min')
    // var arrayfiles =[]
    // let documentId =''
    this.progressAnswer = true
    this.disbleCardAnswer = true

   const dataDocumentFiles = await  movingDocument.filesDocument(this.files,dataDocument.id)

   if(dataDocumentFiles){
    this.progressAnswer = false
    this.disbleCardRever = false
    this.btnDocumentforward=false
   }else{
    console.log('faltou')
   }
    // this.$apollo.mutate({
    //  mutation:require('@/graphql/mutations/Documents.gql').createDocumentSand,
    //  variables: {
    //   number: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
    //   subject: this.documentTitle,
    //   content: this.content,
    //   delivery_time: this.formattedDate,
    //   private: this.privet,
    //   urgent: this.Urgent,
    //   client: this.$store.state.defaultClient.id,
    //   entity: this.$store.state.enti.id,
    //   document_type: this.documentType.id,
    //   user: this.$store.state.userID,
    //   countersign: null,
    //   countersign_user: null,
    //   parent: this.document.id,
    //   att_user: this.selectedUserEntiyforward,
    //   att_entity: this.documentforwardEntity.id,
    //   initial_document:this.documentInital_id
    //  }
				//
    // }).then((data)=> {
				//
    //  // enviando para destinario
    //  this.documentId = data.data.createDocument.id
    //  documentId =  data.data.createDocument.id
    //  this.$apollo.mutate({
    //   mutation: require('@/graphql/mutations/Documents.gql').CreateMutationReceiver,
    //   variables: {
				//
    //    document: this.documentId,
    //    entity: this.documentforwardEntity.id,
    //    user: this.selectedUserEntiyforward,
    //    receiver_type:  this.receiverType,
    //    receiver_category: this.ReceiverCategoryforwarded
    //   }
				//
    //  }).then(() => {
				//
    //  }).catch(({graphQLErrors}) => {
    //   console.error(graphQLErrors)
    //  })
				//
				//
				//
    //  // mando para dentro da minha box enviados
    //  this.$apollo.mutate({
    //   mutation: require('@/graphql/mutations/Documents.gql').CreateMutationReceiver,
    //   variables: {
    //    document: this.documentId,
    //    entity: this.$store.state.enti.id,
    //    user: this.$store.state.userID,
    //    receiver_type: this.receiverTypeFrom,
    //    receiver_category: this.ReceiverCategoryforwarded
    //   }
				//
				//
    //  }).then(() => {
				//
    //   // this.btnAnswerDocument=false
    //   // this.progressAnswer = false
    //  }).catch(({graphQLErrors}) => {
    //   console.error(graphQLErrors)
    //  })
				//
				//
    //  if(this.files.length > 0){
				//
    //   for (let i = 0, numFiles = this.files.length; i < numFiles; i++) {
    //    const file = this.files[i];
				//
    //    this.$apollo.mutate({
    //     mutation:UploadFile,
    //     variables:{
    //      file:file
    //     }
    //    }).then((data)=>{
    //     arrayfiles[i] = data.data.upload
				//
				//
    //     this.$apollo.mutate({
    //      mutation:files,
    //      variables:{
    //       file_name:data.data.upload,
    //       path:data.data.upload,
    //       document:documentId
    //      }
    //      // eslint-disable-next-line no-unused-vars
    //     }).then((data)=>{
				//
    //     }).catch(({graphQLErrors})=>{
    //      console.error(graphQLErrors)
    //     })
				//
    //    }).catch((err)=>{
    //     console.error(err)
    //    })
				//
    //   }
    //  }
    //  this.fetchEvents()
    //  this.progressAnswer = false
    //  this.cancel()
    // }).catch(({graphQLErrors})=>{
    //  console.error(graphQLErrors)
    // })

   },
   answerDocument() {
    this.historyCard = false
    this.btnAnswerDocument = !this.btnAnswerDocument
    this.btnDocumentforward = false
    this.urgent = false
    this.$nextTick(() => this.$vuetify.goTo('#answer'))


   },
   remove(index) {
    this.files.splice(index, 1)
   },

   async	openHistory() {

    this.btnAnswerDocument = false
    this.btnDocumentforward = false

    if(this.documentInital === null){
     this.historyCard = false
     this.historyCardDialog = true

    }else{
     await this.$apollo.query({
      query:require('@/graphql/queries/Documents.gql').getDocumentHistory1,
      variables:{
       id:this.documentInital.id
      },
      fetchPolicy:'network-only'
     }).then((data)=>{
      this.historyCard =  !this.historyCard
      var documentInitial = data.data.document
      let array = []
      var documentDescends = data.data.document.descendants
      delete documentInitial.descendants
      array = documentDescends
      array.unshift(documentInitial)
      this.documentHistory = array
      this.countProcedures = array.length
     }).catch((err)=>{
      console.error(err)
     })

     this.historyCardDialog = false

     this.$nextTick(() => this.$vuetify.goTo('#history'))



    }





   },
   bookmarkDocument() {

    this.favorite = !this.favorite

    this.$apollo.mutate({
     mutation: require("@/graphql/mutations/Documents.gql").updateDocumenfavorit,
     variables: {
      id: this.documentBox.id,
      favorit:this.favorite
     }
    }).then(() => {

    }).catch((err) => {
     console.error(err)
    })

   }


  },
  beforeRouteEnter(to, from, next) {
   if (to.params.id) {
    apolloClient.query({
     query: require('@/graphql/queries/Documents.gql').documentIdshowCurrent,
     variables: {
      id: to.params.id
     },
     fetchPolicy: 'network-only'
    }).then(({data:{document}}) => {
     if (document) {
      next(vm => {
       vm.expandReceive_text = true
       vm.document = document
       vm.filesDocumentCurrent = document.attachments
       if(document.parent ===  null &&  document.initial === null){
        vm.documentInital_id = document.id
       }else if(document.parent === document.initial){
        vm.documentInital = document.parent
        vm.documentInital_id = document.parent.id
        vm.documentUserInitial = document.user
       }else if(document.parent !== null && document.initial !== null){
        if(document.parent  !== document.initial ){
         vm.documentInital = document.initial
         vm.documentInital_id  = document.initial.id
         vm.documentUserInitial = document.user
        }
       }
       if(document.countersign_user !== null){
				 vm.userPositionCountersign = document.countersign_user.entities.filter((e)=>{

					 const entity = e.id === document.entity.id
					 return entity
				 })

			 }
       vm.receive_text = document.content
       vm.documentTitle = document.subject
       vm.documentType = document.document_type.name
       vm.actionDocument = document.receivers[0].receiver_category.name
       vm.documentEntityCreate = document.entity
       if(document.attn_entity !== null){
        vm.documentEntityFor = vm.$options.filters.entityTo(document.receivers)
        vm.documentCure = vm.$options.filters.userTo(document.receivers)
       }

       vm.selectedUserEntiyAc = document.attn_user
       vm.documentCreteUser = document.user
       vm.documentBox = document.document_boxes.filter(e=>{

        if(e.id  === to.query.id_box){
         return e
        }
       })[0]
       if(vm.documentBox.labels !== null){
        vm.labels = vm.documentBox.labels
       }

						vm.countersignUsereye =  document.totalViews

       vm.favorite = vm.documentBox.is_starred
       vm.documentBoxIdcurrent = vm.documentBox.id
       vm.documentFolderIdcurrent = vm.documentBox.folder.id
       // if(vm.documentBox.previous_folder !== null){
       //   vm.documentFolderProviusIdcurrent = vm.documentBox.previous_folder.id
       // }

       vm.urgent = document.urgent
       vm.entityId = document.entity.id
       vm.documentEntityForOb = document.entity

       let counterParent = 0;
       for (let i = 0; i < document.length; i++) {
        if (document[i].parent !== null) counterParent++;
       }
       vm.countProcedures = counterParent + 1

       let countersignUser = 0;
       for (let i = 0; i < document.length; i++) {
        if (document[i].parent !== null) countersignUser++;
       }

       vm.countersignUser = countersignUser

       let options = { year: 'numeric', month: '2-digit', day: '2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit' };
       vm.dateCreateDocument =  new Date(document.created_at).toLocaleDateString('pt-BR', options)

      })
     }
    }).catch((error) => {
     console.log(error)
     console.error('Erro na Consulta', JSON.stringify(error.message))
    })
   } else {
    next()
   }
  },
  mounted() {
   this.fetchEvents()
  },
 }
</script>

<style scoped>
	.teste .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
		border-radius: 2% !important;

	}
</style>